<template>
  <div
    :id="modalId"
    :class="classes"
    :style="this.styles"
    tabindex="-1"
    role="dialog"
  >
    <SidebarComponent ref="filter" :title="$t('generic-str.status.lbl-new')" class="filter-client" :filters="filters" backdrop>
      <div class="modal-dialog">
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="form-body">
              <div class="form-group row">
                <label class="control-label text-left col-md-12 text-left-m"
                  >{{$tc('generic-str.lbl-number', 2)}}</label
                >
                <div class="col-md-12">
                  <textarea
                    v-model="form.numbers"
                    type="text"
                    class="form-control"
                  ></textarea>
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label text-left col-md-12 text-left-m"
                  >{{$t('generic-str.expire')}}</label
                >
                <div class="col-md-12">
                  <date-picker
                    v-model="form.expired_at"
                    :config="options"
                    class="form-control input-date"
                    :placeholder="$t('generic-str.date-hour')"
                  ></date-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
              :disabled="isSending"
              type="submit"
              class="btn btn-yup-purple"
            >
              {{$t('generic-str.save')}}
            </button>
            <button type="button" class="btn btn-yup-purple-outline" @click="hide">
              {{$t('generic-str.cancel')}}
            </button>
          </div>
        </form>
    </div>
    </SidebarComponent>
  </div>
</template>

<script>
import SmsService from '@/services/sms.service';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import SidebarComponent from '@/components/SidebarComponent.vue';
import Modal from '@/mixins/Modal';
import moment from 'moment';

export default {
  mixins: [Modal],
  props: ['id'],
  components: {
    datePicker,
    SidebarComponent,
  },
  data() {
    return {
      form: {},
      isSending: false,
      options: {
        format: 'DD/MM/YYYY HH:mm',
        useCurrent: false,
        keepInvalid: true,
      },
    };
  },
  methods: {
    save() {
      this.isSending = true;
      if (this.form.expired_at) {
        const expiredAt = moment(
          this.form.expired_at,
          'DD/MM/YYYY HH:mm',
        ).format('YYYY-MM-DD HH:mm');
        this.form.expired_at = expiredAt;

        console.log(this.form.expired_at);
        console.log(this.form);
      }
      SmsService.createBlackList({
        expired_at: this.form.expired_at,
        numbers: this.form.numbers,
        channel: 'sms',
      }).then(
        () => {
          this.hide();
          this.$toast.show({
            title: this.$t('generic-str.success'),
            content: 'Deny list criada com sucesso',
            type: 'success',
          });
          this.$emit('submit');
          this.isSending = false;
        },
        (error) => {
          this.$toast.show({
            title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
            content: error.message,
            type: 'danger',
          });
          this.isSending = false;
          console.log(error.response.data.message);
        },
      );
    },
    showFilter() {
      this.$refs.filter.toggle();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
